import { render } from "./ProposalForm.vue?vue&type=template&id=e7135bfc&scoped=true"
import script from "./ProposalForm.vue?vue&type=script&lang=js"
export * from "./ProposalForm.vue?vue&type=script&lang=js"

import "./ProposalForm.vue?vue&type=style&index=0&id=e7135bfc&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7135bfc"]])

export default __exports__